export default __webpack_public_path__ + "static/media/ic-channel.2cc804c8.svg";